<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item
              label="封面图"
              prop="imgUrl"
      >
        <el-upload
                v-model="dataForm.imgUrl"
                :action="uploadUrl"
                list-type="picture-card"
                :file-list="fileList"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="successImgUrl"
                :before-upload="beforeUploadImg"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img
                  width="100%"
                  :src="dataForm.imgUrl"
                  alt=""
          >
        </el-dialog>
      </el-form-item>
      <el-form-item label="课程内容" prop="context">
        <el-input v-model="dataForm.context" placeholder="课程内容"></el-input>
      </el-form-item>
    <!--  <el-form-item label="图片地址" prop="imgUrl">
        <el-input v-model="dataForm.imgUrl" placeholder="图片地址"></el-input>
      </el-form-item>
      -->
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      dialogVisible: false,
      uploadUrl: `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`,
      fileList: [],
      dataForm: {
        id: '',
        classHourId: '',
        classHourName: '',
        context: '',
        imgUrl: '',
        schoolId: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    handlePictureCardPreview (file) {
      this.dataForm.imgUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      //   console.log(file, fileList)
      //   console.log(this.dataForm.imgUrl)
      delete this.dataForm.imgUrl
    },
    // 上传封面图成功
    successImgUrl (res, file, fileList) {
      console.log('success')
      this.dataForm.imgUrl = res.data.src
      this.fileList = []
      this.fileList.push(file)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
    },
    beforeUploadImg (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      // console.log(testmsg)
      const extension = (testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'gif' || testmsg === 'bmp' || testmsg === 'webp' || testmsg === 'png' || testmsg === 'tif')
      // console.log(extension)
      if (!extension) {
        this.$message({
          message: '您上传的图片格式不符合要求!只支持jpg、jpeg、gif、bmp,webp,png,tif',
          type: 'warning'
        })
      }
      // console.log(extension)
      return extension
    },
    // 获取信息
    getInfo () {
      this.$http.get('/club/courseprocess/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/club/courseProcess/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
